import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private router: Router) { }

  canActivate() {
    const user = JSON.parse(localStorage.getItem('USER')!);
    const token = user?.token;
    if (token) {
      return true;
    }
    return this.router.createUrlTree(['/login']);
  }


}
